import { render, staticRenderFns } from "./price.vue?vue&type=template&id=303600c4&scoped=true&lang=html&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303600c4",
  null
  
)

export default component.exports